import Alert from './Alert'

export default class ConfirmationAlert extends Alert {
    show() {
        return new Promise((resolve, reject) => {
            swal({
                title: this.key('title', uLang('app.are_you_sure')),
                text: this.key('text', uLang('app.delete_warning_entity_het', { entity: this.key('entity') })),
                icon: "warning",
                buttons: [
                    this.key('cancelButtonText', uLang('app.cancel')), 
                    this.key('continueButtonText', uLang('app.continue'))
                ],
                dangerMode: true,
                closeOnClickOutside: false,
                closeOnEsc: false,
            })
            .then((willDelete) => {
                if (willDelete) {
                    return resolve();
                } else {
                    return reject();
                }
            }).catch(() => {
                reject();
            });
        });

    }
}
